import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useEventHttp } from '@/core/api/events'
import { Event, EventPayload } from '@/core/models/event'

export type EventCollection = {
    data: Array<Event>,
    meta?: MetaPayload,
    links?: any
}

const state: EventCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const eventCollection: Module<EventCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: EventCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: EventPayload) => {
                state.data.push(new Event(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useEventHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: EventCollection): EventCollection => {
            return state
        }
    }
}